import React, { PureComponent } from "react";

import { TTP_API_URL, TTP_EMAILING_URL } from "Config";
import TalkContainer from "./Talk/TalkContainer";
import SurveyContainer from "./Survey/SurveyContainer";
import WheretobillContainer from "./Wheretobill/WheretobillContainer";
import { SendingWidget } from "../../../sending-widget";

export default class Header extends PureComponent {
  sendingWidget = null;

  componentDidMount() {
    const { widgets } = this.props;
    if (!this.sendingWidget && widgets.includes("SENDING")) {
      this.sendingWidget = new SendingWidget({
        url: TTP_EMAILING_URL
      });
    }
  }

  componentWillUnmount() {
    if (this.sendingWidget) {
      this.sendingWidget = null;
    }
  }

  initEmail = () => {
    const { language } = this.props;
    // const { id, email, legalRepresentative } = directory;

    // const { mainEmail } = legalRepresentative;
    if (!this.sendingWidget) {
      return;
    }
    this.sendingWidget.showEmailWidget({
      recipientId: "id",
      recipientType: "CONTACT",
      email: "",
      language
    });
  };

  render() {
    const { community, widgets } = this.props;

    if (
      !widgets.includes("SURVEY") &&
      !widgets.includes("TALK_BOX") &&
      !widgets.includes("WHERETOBILL") &&
      !widgets.includes("SENDING")
    ) {
      return null;
    }

    const { avatarWebPath, avatarUrl } = community;

    const logo = avatarUrl
      ? avatarUrl
      : avatarWebPath
        ? `${TTP_API_URL}'/'${avatarWebPath}`
        : "/img/community-default-logo.png";

    return (
      <div id="new-community-header">
        <div className="body-header grid-x">
          <div className="logo cell small-12 medium-6 large-3">
            <img src={logo} alt={community.name} />
          </div>
          {widgets.includes("TALK_BOX") && <TalkContainer />}
          {widgets.includes("SURVEY") && <SurveyContainer />}
          {widgets.includes("WHERETOBILL") && <WheretobillContainer />}

          {widgets.includes("SENDING") && (
            <img
              src="/img/icons/send.svg"
              alt="envelope"
              onClick={this.initEmail.bind(this)}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Header.js